import {Button, Cluster, Dialog, Heading, Icon, Paragraph, Stack, Table, TdLink, Template} from '@pluto-tv/assemble';
import {IClipWithMoreRestrictiveRating} from 'models/clips';
import React from 'react';
import {getPrefixedUrl} from 'routes';
import clipRoutes from 'routes/content.routes';

interface IClipsRatingListModalProps {
  isOpen: boolean;
  isSaving: boolean;
  handleConfirm: () => void;
  handleDiscard: () => void;
  onClose: () => void;
  clipsWithMoreRestrictiveRating: IClipWithMoreRestrictiveRating[];
}

const ClipsRatingListModal = React.memo(
  ({
    isOpen,
    onClose,
    isSaving = false,
    clipsWithMoreRestrictiveRating,
    handleConfirm,
    handleDiscard,
  }: IClipsRatingListModalProps) => {
    return (
      <Dialog isOpen={isOpen} onClose={onClose} width='70.5rem' height='40.5rem'>
        <Template label='header'>
          <Heading level='h2'>
            <Icon icon='warning' color='warning' space='xxsmall'>
              Confirm changes
            </Icon>
          </Heading>
        </Template>
        <Template label='body'>
          <Stack space='large'>
            <Icon icon='warning' size='medium' iconAlign='start' space='xxsmall' color='warning'>
              <Stack space='xxsmall'>
                <Paragraph color='secondary'>
                  You are about to change the associated clip(s) rating to a less restrictive one.
                </Paragraph>
              </Stack>
            </Icon>
          </Stack>
          <Stack space='small'>
            <Table
              rows={clipsWithMoreRestrictiveRating}
              cols={[
                {
                  label: 'Clip Name',
                  colMaxWidth: '30rem',
                  transform: (clip: IClipWithMoreRestrictiveRating) => {
                    const editDetailsUrl = getPrefixedUrl(clipRoutes.paths.clipEditDetailsPage.replace(':id', clip.id));
                    return <TdLink title={clip.name} row={clip} url={editDetailsUrl} target='_blank' rel='opener' />;
                  },
                },
                {
                  label: 'Current Rating',
                  field: 'rating',
                },
              ]}
            />
          </Stack>
        </Template>
        <Template label='footer'>
          <Cluster justify='space-between'>
            <Button type='solid' state={isSaving ? 'disabled' : ''} size='small' onClick={handleDiscard}>
              Discard Changes
            </Button>
            <Cluster space='small'>
              <Button size='small' state={isSaving ? 'thinking' : ''} type='primary' onClick={handleConfirm}>
                Save and Proceed
              </Button>
            </Cluster>
          </Cluster>
        </Template>
      </Dialog>
    );
  },
);

ClipsRatingListModal.displayName = 'ClipsRatingListModal';
export default ClipsRatingListModal;
